import React from "react";
import { Box, Divider } from "@chakra-ui/react";
import { useCurrentCase } from "duck";
import { SpeciesEnum } from "requests";
import { Medications, NotesForm, TestsAndVaccines } from "./components";

const Notes: React.FC = () => {
  const species = useCurrentCase(
    medCase => medCase.data.client.patient.species
  );

  const hasTestsAndVaccines =
    species === SpeciesEnum.Cat || species === SpeciesEnum.Dog;

  return (
    <>
      {hasTestsAndVaccines && <TestsAndVaccines />}

      {hasTestsAndVaccines && (
        <Box mx="-8">
          <Divider my={8} />
        </Box>
      )}

      <NotesForm />

      <Box mt={12}>
        <Medications />
      </Box>
    </>
  );
};

export default Notes;
